import React from "react";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Globalize from "globalize";
import { themeOptions } from "styles/theme";
import { DATATEST } from "constants/integration";

const styles = {
    snackActionBtn: {
        fontSize: 14,
        fontFamily: themeOptions.palette.fontFamily,
        textTransform: "none" as "none",
        color: themeOptions.palette.accent1Color,
    },
};

interface ISnackBarItemAddActionsProps {
    onClose: () => void;
    onSecondaryAction?: () => void;
    onPrimaryAction: () => void;
    primaryLabel?: string;
    secondaryLabel?: string;
}

const SnackBarItemAddActions: React.FC<ISnackBarItemAddActionsProps> = ({
    onClose,
    onSecondaryAction,
    onPrimaryAction,
    primaryLabel,
    secondaryLabel,
}) => {
    return (
        <React.Fragment>
            <Button
                data-test={DATATEST.SNACKBAR_VIEW_CART}
                color="primary"
                onClick={onPrimaryAction}
                style={styles.snackActionBtn}
            >
                {primaryLabel ?? Globalize.formatMessage("View Cart")}
            </Button>
            {onSecondaryAction && (
                <Button
                    data-test={DATATEST.SNACKBAR_UNDO}
                    color="primary"
                    onClick={onSecondaryAction}
                    style={styles.snackActionBtn}
                >
                    {secondaryLabel ?? Globalize.formatMessage("Undo")}
                </Button>
            )}
            <IconButton role="img" size="small" color="inherit" onClick={onClose}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
};

export default SnackBarItemAddActions;
